import { IconButton, Paper } from '@material-ui/core'
import { Close, GetApp, InsertDriveFile } from '@material-ui/icons'
import { useDispatch } from 'react-redux'
import { downloadFile } from '../../actions/fileActions'
import OverflowTooltip from '../Tooltip/OverflowTooltip'

interface Props {
  file: IFile | AcceptanceCriteria
  handleRemoveClick?: () => void
}

const SingleFileDisplay = ({ file, handleRemoveClick }: Props) => {
  const dispatch = useDispatch()

  const handleDownloadClick = () => {
    dispatch(downloadFile(file))
  }

  return (
    <>
      <Paper
        className="single-file-display"
        style={{
          borderRadius: 0,
          display: 'block',
        }}
      >
        <div className="flex space-between fs12 align-center flex-grow">
          <div
            className="primary flex space-between align-center flex-grow"
            style={{ width: '100%' }}
          >
            <div
              className="flex align-center"
              style={{ maxWidth: 'calc(100% - 48px' }}
            >
              <InsertDriveFile className="m-r-5" style={{ fontSize: 12 }} />

              <OverflowTooltip
                title={file.name}
                style={{ maxWidth: 'calc(100% - 24px)' }}
                content={null}
                children={null}
              />
            </div>
            <div className="text-right">
              <IconButton className="small" onClick={handleDownloadClick}>
                <GetApp style={{ color: 'black' }} />
              </IconButton>
              {handleRemoveClick && (
                <IconButton className="small" onClick={handleRemoveClick}>
                  <Close style={{ color: 'black' }} />
                </IconButton>
              )}
            </div>
          </div>
        </div>
      </Paper>
    </>
  )
}

export default SingleFileDisplay
